export default __webpack_public_path__ + "static/media/html5.e1a5193d.png";